export const expenseItems = {
  title: '费用科目',
  titles: {
    create: '新增费用科目',
    edit: '编辑费用科目',
    detail: '费用科目详情',
    list: '费用科目目录',
    addQuick: '快速添加',
  },
  sections: {
    basic: '基本信息',
  },
  fields: {
    code: '科目代码',
    name: '费用科目',
    templateContent: '模板内容',
    defaultCurrency: '默认币种',
    sortOrder: '排序',
    status: '状态',
    onOffAction: '开/关',
    actions: '操作',
    createdAt: '创建时间',
    updatedAt: '更新时间',
  },
  status: {
    active: '启用',
    inactive: '停用',
  },
  messages: {
    noData: '暂无数据',
  },
  filter: {
    placeholder: '按代码或科目名称搜索...',
  },
}
